import styled from 'styled-components';

export const Nav = styled.nav`
  min-height: 56px;
  padding: 0 16px;
  background: ${(props) => props.theme.$white};
  box-shadow: 0 4px 2px rgb(51 51 51 / 10%);

  .logo-conlicitaseg {
    gap: 8.71px;
    flex-shrink: 1;
    min-width: 0;
  }

  .navbar-nav {
    gap: 16px;
  }

  .logo-conlicitacao {
    margin-right: 8px; /* 24px até o grupo Ajuda/avatar; 16px entre Ajuda e avatar */
  }

  .tour-ajuda-button {
    font-size: 16px;
    padding: 9px 12px;
    line-height: normal;
    border-radius: 4px;
  }

  .nav-link {
    color: ${(props) => props.theme.$dark};
  }

  .nav-link-menu {
    height: 56px;
  }

  .user-dropdown {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .user-avatar {
    width: 34px;
    height: 34px;
    background: ${(props) => props.theme.$info};
    color: ${(props) => props.theme.$white};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
  }

  .dropdown-menu {
    position: absolute !important;
    top: 56px;

    &.dropdown-menu-right {
      right: 0;
    }
  }

  .dropdown-menu .locked-overlay .dropdown-item {
    padding-right: 40px;
  }

  .dropdown-menu .locked-overlay .lock-badge {
    top: 50%;
    right: 12px;
    bottom: auto;
    transform: translateY(-50%);
  }

  @media only screen and (max-width: 576px) {
    .logo-texto {
      width: 96px;
      height: auto;
    }

    .logo-conlicitacao {
      margin-right: 0;
    }

    .logo-conlicitacao img {
      width: 104px;
      height: auto;
    }

    .navbar-nav {
      gap: 8px;
    }
  }
`;
